import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InService } from '@flyfreely-portal-ui/flyfreely';
import { FormatDurationPipe } from 'libs/ui/src/lib/pipes';
import moment, { Moment } from 'moment';

@Pipe({
    name: 'formatInServiceTime'
})
export class FormatInServiceTimePipe implements PipeTransform {
    constructor(
        private durationPipe: FormatDurationPipe,
        private domSanitizer: DomSanitizer
    ) {}
    /**
     * A formatter pipe that converts an InService object to a string denoting time until service
     * as compared to the comparisonTime.
     * @param time The time in service to display
     * @param sinceOrUntil is the time a calculation since the comparision time, or until it
     * @param comparisonTime The time point to use for the time in service.
     * This can be used to display time in service as it was at a point in time, such as when
     * maintenance was performed, or can be given the current system time for comparisons to now.
     * @returns A string showing the times until the next service
     */
    transform(
        time: InService,
        sinceOrUntil: 'SINCE' | 'UNTIL' = 'SINCE',
        comparisonTime?: string | Date | Moment
    ): SafeHtml {
        let ret = '';
        if (time.time != null) {
            ret += `<b>Time:</b>&nbsp;${this.durationPipe.transform(
                time.time
            )} `;
        }
        if (time.cycles != null) {
            ret += `<b>Cycles:</b>&nbsp;${time.cycles} `;
        }
        if (time.timestamp != null) {
            if (sinceOrUntil === 'SINCE') {
                ret += `<b>Days:</b>&nbsp;${moment(comparisonTime)
                    .endOf('day')
                    .diff(moment(time.timestamp).startOf('day'), 'days')}`;
            } else {
                ret += `<b>Days:</b>&nbsp;${moment(time.timestamp)
                    .startOf('day')
                    .diff(moment(comparisonTime).endOf('day'), 'days')}`;
            }
        }
        return this.domSanitizer.bypassSecurityTrustHtml(ret);
    }
}
